import { render, staticRenderFns } from "./ProductFooterMobile.vue?vue&type=template&id=376de266&scoped=true"
import script from "./ProductFooterMobile.vue?vue&type=script&lang=js"
export * from "./ProductFooterMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductFooterMobile.vue?vue&type=style&index=0&id=376de266&prod&scoped=true&lang=scss"
import style1 from "./ProductFooterMobile.vue?vue&type=style&index=1&id=376de266&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376de266",
  null
  
)

export default component.exports